import { render } from "./NavigationForm.vue?vue&type=template&id=1018fa48&scoped=true"
import script from "./NavigationForm.vue?vue&type=script&lang=js"
export * from "./NavigationForm.vue?vue&type=script&lang=js"

import "./NavigationForm.vue?vue&type=style&index=0&id=1018fa48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1018fa48"]])

export default __exports__